import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-images',
    templateUrl: './images.component.html',
    styleUrls: ['./images.component.scss'],
    standalone: false
})
export class ImagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
